import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { Component } from "react";
import { connect } from "react-redux";
import { getSubscriptionPlan } from "../../../modules/subscription/action";
import "../../../style";




const styles = {
  card: {
    minWidth: 275
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  col: {
    backgroundColor: "#00bc84",
    color: "#fff"
  }
};

const planDetails = {
  capabilities: [
    ,
    "Limited Risk Management and Reconciliation Capabilities",
    "Full Risk Management and Reconciliation Services",
    "Full Risk Management and Reconciliation Services",
    "Full Risk Management and Reconciliation Services"
  ],
  support: [
    ,
    "Limited Support",
    "Support Service (online and phone)",
    "Support Service (online and phone)",
    "Onsite Training and Support Service (Online and Phone)"
  ],
  print: [
    ,
    "Mobile Print add on",
    "Mobile Print add on",
    "Mobile Print add on",
    "Mobile Print add on"
  ]
};

class SubscriptionPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false
    };
  }

  componentWillMount() {
    this.props.getSubscriptionPlan();
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.subscriptionList &&
      this.props.subscriptionList !== nextProps.subscriptionList &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
      let a = nextProps.subscriptionList;
      console.log("asdasda", a);
    }
  }
  render() {
    const { subscriptionList = [] } = this.props;
    console.log("subscriptionList", subscriptionList);
    let a =
      subscriptionList &&
      Object.keys(subscriptionList).map((data, index) => {});
    console.log(a, "a");
    const { classes } = this.props;
    // const bull = <span className={classes.bullet}>•</span>;
    return (
      <Grid container spacing={8}>
        {this.state.fetchingComplete
          ? Object.keys(subscriptionList).map((data, index) => (
              <Grid item sm={3} xs={12} key={index}>
                <Card className={classes.card} className="Card">
                  <CardContent className="cardContent">
                    <h3 className="cardContentTitle">
                      {subscriptionList[data].name}
                    </h3>
                    <p className="subscripCharge">
                      <span className="currency">
                        {subscriptionList[data].currency}
                      </span>
                      {subscriptionList[data].fees}
                    </p>
                    <Typography className={classes.pos} color="textSecondary">
                      Annually
                    </Typography>
                    <p className="planList">
                      {`${subscriptionList[data].noOfLogins} Logins`}
                    </p>
                    <p className="planList">
                      {`${
                        subscriptionList[data].noOfTickets !== -1
                          ? `Up to ${subscriptionList[data].noOfTickets}`
                          : "Unlimited"
                      } Tickets`}
                    </p>
                    <p className="planList">
                      {`${
                        subscriptionList[data].noOfContracts !== -1
                          ? `Up to ${subscriptionList[data].noOfContracts}`
                          : "Unlimited"
                      } Contracts`}
                    </p>
                    <p className="planList">
                      {subscriptionList[data].name === "Basic" ? "Limited" : ""}{" "}
                      Print and Export Capabilities
                    </p>
                    <p className="planList">
                      {planDetails.capabilities[subscriptionList[data].id]}
                    </p>
                    <p className="planList">
                      {planDetails.support[subscriptionList[data].id]}
                    </p>
                    <p className="planList">
                      {planDetails.print[subscriptionList[data].id]}
                    </p>
                  </CardContent>
                </Card>
              </Grid>
            ))
          : null}
      </Grid>
    );
  }
}

// SubscriptionPlan.propTypes = {
//     classes: PropTypes.object.isRequired,
//   };

function mapStateToProps(state, props) {
  return {
    subscriptionList: state.subscriptionList.subscriptionListDetails
  };
}
export default connect(
  mapStateToProps,
  { getSubscriptionPlan }
)(withStyles(styles)(SubscriptionPlan));



// WEBPACK FOOTER //
// ./src/components/public/Home/SubscriptionPlans.js